module.exports = __webpack_public_path__ + "static/media/redParrot.f256f50f.png";